/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{GLObjectType as t}from"../../webgl/GLObjectType.js";function e(e){return e?.attachment.type===t.Texture}export{e as isManagedDepthTexture};
